import { verify, constrain, Type, Constraint, optional, adjust, either } from 'specified';
import { v4 } from 'uuid';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { QueryString } from '@grandvision/utils';
import { placePredictionsResponseSpec, coordinatesResponseSpec } from '@grandvision/location-model';
import { useReducer, useEffect } from 'react';



var types = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var okOrThrow = function (response) {
    if (!response.ok) {
        var error = new Error("Request to " + response.url + " failed: " + response.status + " - " + response.statusText + ".");
        error.statusCode = response.status;
        throw error;
    }
};
var unwrapResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (response.status === 422) {
                    return [2 /*return*/, response.json().then(function (error) {
                            throw error;
                        })];
                }
                okOrThrow(response);
                return [4 /*yield*/, response.json()];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
var validateResponse = function (spec, response) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, err, value, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                okOrThrow(response);
                _b = verify;
                _c = [spec];
                return [4 /*yield*/, response.json()];
            case 1:
                _a = _b.apply(void 0, _c.concat([_d.sent()])), err = _a.err, value = _a.value;
                if (err) {
                    throw err;
                }
                return [2 /*return*/, value()];
        }
    });
}); };

var jsonMimeType = 'application/json';
var acceptJson = {
    Accept: jsonMimeType,
};
var postJson = {
    'Content-Type': jsonMimeType,
};
var authHeader = function (accessToken) { return ({
    Authorization: "Bearer " + accessToken,
}); };
var apigeeApiKey = function (key) {
    return key ? { 'X-API-Key': key } : {};
};
var correlationHeader = function () {
    return { 'X-Correlation-ID': v4() };
};

var integerSpec = constrain(Type.number, [Constraint.number.integer]);
var positiveIntegerSpec = constrain(integerSpec, [Constraint.number.atLeast(0)]);
var integerAbove0 = constrain(integerSpec, [Constraint.number.above(0)]);
var nonEmptyStringSpec = constrain(Type.string, [Constraint.string.notEmpty]);
var isoDateSpec = Type.string; // @TODO: Need more spec constraints
/**
 * This constraint is copied from the customer-service, here: https://github.com/GrandVisionHQ/customer-service/blob/edd52993ff3b36fdb7472dd0eb4441fd31c41777/src/interface/models.ts#L21-L23
 * Explanation of regex: https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
 */
var emailRegexConstraint = Constraint.string.regex(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

var addressSpec = Type.map(Type.string, Type.string);
var baseAddressContainer = {
    isPreferredBillingAddress: optional(Type.boolean),
    isPreferredShippingAddress: optional(Type.boolean),
    address: addressSpec,
};
var addressContainerSpec = adjust(Type.object(__assign(__assign({}, baseAddressContainer), { id: Type.string, createdAt: optional(isoDateSpec), updatedAt: optional(isoDateSpec) })), { strict: false });
var addressContainerRequestSpec = adjust(Type.object(baseAddressContainer), {
    strict: false,
});
var addressListSpec = Type.array(addressContainerSpec);
var addressListResponse = addressListSpec;

var create = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken, addressContainer = _a.addressContainer;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [addressListResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/address-book/" + encodeURIComponent(customerId) + "/addresses", {
                            method: 'POST',
                            headers: __assign(__assign({}, postJson), authHeader(accessToken)),
                            body: JSON.stringify(addressContainer),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};

var list = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [addressListResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/address-book/" + encodeURIComponent(customerId) + "/addresses", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};



var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Types: types,
    create: create,
    list: list
});

// TODO: publish @grandvision/appointment-model
var typename = function (name) {
    var _a;
    return optional(Type.literal((_a = {}, _a[name] = 1, _a)));
};
var localizedString = Type.map(Type.string, Type.string);
var durationSchema = {
    __typename: typename('Duration'),
    amount: Type.number,
    unit: Type.literal({ MINUTES: 1, HOURS: 1 }),
};
var priceSchema = {
    __typename: typename('Price'),
    amount: Type.number,
    currency: Type.string,
};
var appointmentTypeSchema = {
    __typename: typename('AppointmentType'),
    customerRequired: Type.boolean,
    duration: adjust(Type.object(durationSchema), { strict: false }),
    id: Type.string,
    label: Type.string,
    name: Type.string,
    additionalTags: optional(Type.map(Type.string, Type.string)),
    opticianRequired: Type.boolean,
    price: either(Type.null, adjust(Type.object(priceSchema), { strict: false })),
    tryInStore: Type.boolean,
    visibleToCustomers: Type.boolean,
};
var appointmentSchema = {
    __typename: typename('Appointment'),
    id: Type.string,
    status: Type.string,
    startTime: Type.string,
    endTime: Type.string,
    appointmentType: adjust(Type.object({
        __typename: typename('AppointmentType'),
        id: Type.string,
        name: Type.string,
        duration: adjust(Type.object(durationSchema), { strict: false }),
    }), { strict: false }),
    store: adjust(Type.object({
        __typename: typename('Store'),
        id: Type.string,
        code: Type.string,
        name: Type.string,
    }), { strict: false }),
};
var matrixValue = either(Type.number, Type.string, Type.boolean, Type.null);
var matrixDependency = Type.map(Type.string, optional(Type.array(matrixValue)));
var matrixOption = adjust(Type.object({
    __typename: typename('Option'),
    value: matrixValue,
    label: localizedString,
    description: either(localizedString, Type.null),
    tooltipKey: optional(either(Type.string, Type.null)),
    default: either(Type.boolean, Type.null),
}), { strict: false });
var matrixSchema = {
    __typename: typename('TypesMatrix'),
    properties: Type.array(adjust(Type.object({
        __typename: typename('Property'),
        name: Type.string,
        parents: Type.array(Type.string),
        showWhen: Type.array(matrixDependency),
        requiredWhen: Type.array(matrixDependency),
        title: localizedString,
        description: localizedString,
        options: Type.array(matrixOption),
        optional: either(Type.boolean, Type.null),
        renderInECommerceAs: either(Type.string, Type.null),
    }), { strict: false })),
};
var timeSlotResponseSchema = {
    __typename: typename('TimeSlot'),
    from: Type.string,
    until: Type.string,
};
var appointmentResponseSpec = adjust(Type.object(appointmentSchema), { strict: false });
var appointmentListResponseSpec = Type.array(appointmentResponseSpec);
var appointmentTypeResponseSpec = adjust(Type.object(appointmentTypeSchema), {
    strict: false,
});
var appointmentTypesResponseSpec = Type.array(adjust(Type.object(appointmentTypeSchema), { strict: false }));
var appointmentTypesMatrixResponseSpec = adjust(Type.object(matrixSchema), {
    strict: false,
});
var timeSlotsResponseSpec = Type.array(adjust(Type.object(timeSlotResponseSchema), { strict: false }));
var availabilityResponseSpec = Type.array(adjust(Type.object({
    __typename: typename('Availability'),
    percentageAvailable: Type.number,
    slotsAvailable: Type.number,
    storeCode: Type.string,
    perDay: Type.map(Type.string, adjust(Type.object({ slotsAvailable: Type.number, percentageAvailable: Type.number }), {
        strict: false,
    })),
}), { strict: false }));
var createCustomerResponseSpec = adjust(Type.object({
    data: adjust(Type.object({
        createCustomer: adjust(Type.object({
            id: Type.string,
        }), { strict: false }),
    }), { strict: false }),
}), { strict: false });
var createAppointmentResponseSpec = adjust(Type.object({
    __typename: typename('Appointment'),
    id: Type.string,
    startTime: Type.string,
    endTime: Type.string,
    status: Type.string,
    createdBy: either(Type.string, Type.null),
    customerComment: either(Type.string, Type.null),
    bookingChannel: either(Type.string, Type.null),
    store: adjust(Type.object({
        __typename: typename('Store'),
        id: Type.string,
        code: Type.string,
        name: Type.string,
        phone: either(Type.string, Type.null),
        address: adjust(Type.object({
            __typename: typename('StoreAddress'),
            country: Type.string,
            city: Type.string,
            postalCode: Type.string,
            line1: either(Type.string, Type.null),
            line2: either(Type.string, Type.null),
        }), { strict: false }),
        timeZone: either(Type.string, Type.null),
        url: either(Type.string, Type.null),
    }), { strict: false }),
    additionalTags: optional(either(Type.map(Type.string, Type.string), Type.null)),
}), { strict: false });

function availability(apiUrl, query) {
    return __awaiter(this, void 0, void 0, function () {
        var filterNullable, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    filterNullable = omitBy(query, isNil);
                    _a = validateResponse;
                    _b = [availabilityResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/availability" + (query ? QueryString.stringify(filterNullable) : ''), {
                            method: 'GET',
                            headers: __assign({}, acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function type(apiUrl, typeId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentTypeResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointment-types/" + typeId, {
                            method: 'GET',
                            headers: __assign({}, acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function types$1(apiUrl, query) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentTypesResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointment-types" + (query ? QueryString.stringify(query) : ''), {
                            method: 'GET',
                            headers: __assign({}, acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function typesMatrix(apiUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentTypesMatrixResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointment-types-matrix", {
                            method: 'GET',
                            headers: __assign({}, acceptJson),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function create$1(apiUrl, request, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [createAppointmentResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), (accessToken ? authHeader(accessToken) : {})),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function get(apiUrl, appointmentId, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments/" + appointmentId, {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function cancel(apiUrl, appointmentId, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments/" + appointmentId, __assign({ method: 'DELETE', headers: __assign(__assign({}, acceptJson), authHeader(accessToken)) }, (request ? { body: JSON.stringify(request) } : {})))];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function list$1(apiUrl, accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [appointmentListResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function timeSlots(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [timeSlotsResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/time-slots", {
                            method: 'POST',
                            headers: __assign(__assign({}, acceptJson), postJson),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function timeSlotsForStores(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var storeCodes, rest;
        return __generator(this, function (_a) {
            storeCodes = request.storeCodes, rest = __rest(request, ["storeCodes"]);
            return [2 /*return*/, Promise.all(storeCodes.map(function (storeCode) {
                    return timeSlots(apiUrl, __assign({ storeCode: storeCode }, rest));
                }))];
        });
    });
}

var unlink = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var appointmentId, appointmentToken, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                appointmentId = request.appointmentId, appointmentToken = request.appointmentToken;
                return [4 /*yield*/, fetch(apiUrl + "/appointments/api/v1/appointments/" + appointmentId + "/customer?appointmentDataToken=" + appointmentToken, {
                        method: 'DELETE',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1:
                response = _a.sent();
                okOrThrow(response);
                return [2 /*return*/, response];
        }
    });
}); };



var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    availability: availability,
    type: type,
    types: types$1,
    typesMatrix: typesMatrix,
    create: create$1,
    get: get,
    cancel: cancel,
    list: list$1,
    timeSlots: timeSlots,
    timeSlotsForStores: timeSlotsForStores,
    unlink: unlink
});

var unwrapCartResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!response.ok) return [3 /*break*/, 2];
                return [4 /*yield*/, response.json()];
            case 1: return [2 /*return*/, (_a.sent())];
            case 2:
                if (response.status < 500) {
                    return [2 /*return*/, response.json().then(function (error) {
                            throw error;
                        })];
                }
                throw new Error("Got non OK response from server; " + response.status + " " + response.statusText);
        }
    });
}); };
var defaultCartExpands = [
    'shippingInfo.discountedPrice.includedDiscounts[*].discount',
    'lineItems[*].discountedPrice.includedDiscounts[*].discount',
    'lineItems[*].price.discounted.discount',
    'discountCodes[*].discountCode',
    'lineItems[*].variant.attributes[*].value',
];
var cartExpansionParam = "expand=" + encodeURIComponent(defaultCartExpands.join('|'));

var getCart = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.cartId + "?" + cartExpansionParam, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var createCart = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/", {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify(request.cartDraft),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var updateCart = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.cartId + "/update?" + cartExpansionParam, {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify({ cartVersion: request.cartVersion, actions: request.actions }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var replicateCart = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/replicate", {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify({ reference: request.reference }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getShippingMethods = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.cartId + "/shippingMethods", {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var setLineItemQuantity = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var cartVersion, cartId, lineItemId, lineItemQuantity, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cartVersion = request.cartVersion, cartId = request.cartId, lineItemId = request.lineItemId, lineItemQuantity = request.lineItemQuantity;
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + cartId + "/" + lineItemId + "/quantity?" + cartExpansionParam, {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify({
                            cartVersion: cartVersion,
                            lineItemQuantity: lineItemQuantity,
                        }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var addLineItem = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var cartId, cartVersion, lineItemDraft, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cartId = request.cartId, cartVersion = request.cartVersion, lineItemDraft = request.lineItemDraft;
                _a = unwrapCartResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + cartId + "/lineItems?" + cartExpansionParam, {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify(__assign({ cartVersion: cartVersion }, lineItemDraft)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

/**
 * These are error codes that can be returned by the cart service on any cart create/update call.
 * These errors will have corresponding labels in Bloomreach that can be used to notify the user about the type of error that occurred.
 */
var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode["ContainsMutuallyExclusiveProductTypes"] = "ContainsMutuallyExclusiveProductTypes";
    ValidationErrorCode["MaxQuantitySkuExceeded"] = "MaxQuantitySkuExceeded";
    ValidationErrorCode["MaxMasterVariantQuantityExceeded"] = "MaxMasterVariantQuantityExceeded";
    ValidationErrorCode["MaxVariantsPerProductTypeQuantityExceeded"] = "MaxVariantsPerProductTypeQuantityExceeded";
    ValidationErrorCode["QuantityExceededPrescriptionExpiryDate"] = "QuantityExceededPrescriptionExpiryDate";
    ValidationErrorCode["UnavailableProductsInCart"] = "UnavailableProductsInCart";
    ValidationErrorCode["PrescriptionGlassesInvalidBundleCombination"] = "PrescriptionGlassesInvalidBundleCombination";
    ValidationErrorCode["PrescriptionGlassesInvalidOpticalParameters"] = "PrescriptionGlassesInvalidOpticalParameters";
})(ValidationErrorCode || (ValidationErrorCode = {}));



var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getCart: getCart,
    createCart: createCart,
    updateCart: updateCart,
    replicateCart: replicateCart,
    getShippingMethods: getShippingMethods,
    setLineItemQuantity: setLineItemQuantity,
    addLineItem: addLineItem,
    get ValidationErrorCode () { return ValidationErrorCode; }
});

function changePassword(apiUrl, accessToken, customerId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/account/password/" + encodeURIComponent(customerId) + "/change", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

function resetPassword(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/account/password/reset", {
                            method: 'POST',
                            headers: __assign(__assign({}, acceptJson), postJson),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}



var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    changePassword: changePassword,
    resetPassword: resetPassword
});



var types$2 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var prescriptionContentSpec = adjust(Type.object({
    power: Type.string,
    baseCurve: Type.string,
    diameter: Type.string,
    cylinder: optional(Type.string),
    axis: optional(Type.string),
    addition: optional(Type.string),
    productId: optional(Type.string),
}), { strict: false });
var prescriptionSpec = adjust(Type.object({
    id: Type.string,
    name: Type.string,
    issueDate: isoDateSpec,
    expiryDate: isoDateSpec,
    storeName: Type.string,
    storeId: optional(Type.string),
    recommendedNextEyeTestDate: optional(isoDateSpec),
    validityStatus: Type.literal({
        VALID: 1,
        INVALID: 1,
    }),
    leftEye: prescriptionContentSpec,
    rightEye: prescriptionContentSpec,
}), { strict: false });
var prescriptionsListSpec = Type.array(prescriptionSpec);

function list$2(apiUrl, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [prescriptionsListSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(request.customerId) + "/prescriptions", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function signedPrescriptions(apiUrl, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(request.customerId) + "/signedprescriptions", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}



var index$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    list: list$2,
    signedPrescriptions: signedPrescriptions
});



var types$3 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var currencySpec = Type.literal({ EUR: 1, GBP: 1 });
var moneySpec = adjust(Type.object({
    amount: positiveIntegerSpec,
    currency: currencySpec,
    precision: integerAbove0,
}), { strict: false });
var deliverySpec = adjust(Type.object({
    reference: optional(Type.string),
    date: isoDateSpec,
    boxesPerEyeSide: optional(positiveIntegerSpec),
    status: Type.literal({
        PENDING: 1,
        READY: 1,
        SHIPPED: 1,
        DELIVERED: 1,
    }),
}), { strict: false });
var lineItemSpec = adjust(Type.object({
    productId: Type.string,
    quantity: integerAbove0,
    application: Type.array(Type.literal({ LEFT_EYE: 1, RIGHT_EYE: 1 })),
}), { strict: false });
var paymentMethodSpec = adjust(Type.object({
    type: Type.string,
    details: Type.map(Type.string, Type.string),
}), { strict: false });
var pauseOptionSpec = adjust(Type.object({
    amount: integerSpec,
    unit: Type.literal({
        MONTHS: 1,
    }),
}), { strict: false });
var subscriptionSpec = adjust(Type.object({
    id: Type.string,
    expiryDate: isoDateSpec,
    status: Type.literal({
        ACTIVE: 1,
        PAUSED: 1,
        EXPIRED: 1,
        CANCELLED: 1,
        ON_HOLD: 1,
        PENDING: 1,
    }),
    pendingChanges: Type.array(Type.literal({
        pause: 1,
        quantity: 1,
    })),
    pauseOptions: Type.array(pauseOptionSpec),
    billing: adjust(Type.object({
        totalPricePerInstallment: moneySpec,
    }), { strict: false }),
    deliveries: Type.array(deliverySpec),
    deliveryFrequency: optional(Type.literal({
        WEEKLY: 1,
        BI_WEEKLY: 1,
        MONTHLY: 1,
        QUARTERLY: 1,
        ANNUALLY: 1,
    })),
    deliveryAddress: Type.map(Type.string, Type.string),
    billingAddress: optional(Type.map(Type.string, Type.string)),
    lineItems: Type.array(lineItemSpec),
    paymentMethod: paymentMethodSpec,
    topUpAllowed: Type.boolean,
    quantityChangeable: Type.boolean,
    installments: Type.array(adjust(Type.object({
        date: isoDateSpec,
        totalPrice: moneySpec,
        paymentMethod: Type.string,
        status: Type.literal({
            PAID: 1,
            PENDING: 1,
            CANCELLED: 1,
            FAILED: 1,
            PLANNED: 1,
        }),
    }), { strict: false })),
    custom: optional(Type.map(Type.string, Type.unknown)),
}), { strict: false });
var subscriptionListItemSpec = adjust(Type.object({
    id: Type.string,
}), { strict: false });
var subscriptionList = Type.array(subscriptionListItemSpec);
var subscriptionListResponse = adjust(Type.object({
    subscriptions: subscriptionList,
}), { strict: false });

function details(apiUrl, accessToken, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [subscriptionSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(request.customerId) + "/subscription/" + request.subscriptionId, {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}

function pause(apiUrl, accessToken, customerId, subscriptionId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = okOrThrow;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/subscription/" + subscriptionId + "/pause", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

function quantity(apiUrl, accessToken, customerId, subscriptionId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/subscription/" + subscriptionId + "/quantity", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

var list$3 = function (apiUrl, _a) {
    var customerId = _a.customerId, accessToken = _a.accessToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = validateResponse;
                    _c = [subscriptionListResponse];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/subscriptions", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _b.apply(void 0, _c.concat([_d.sent()]))];
            }
        });
    });
};



var index$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    details: details,
    pause: pause,
    quantity: quantity,
    list: list$3
});



var types$4 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var personalDetailsSchema = {
    personalDetails: Type.map(Type.string, Type.unknown),
};
var personalDetailsResponseSpec = adjust(Type.object(personalDetailsSchema), {
    strict: false,
});
var personalDetailsRequestSpec = Type.object(personalDetailsSchema);
var createAccountResponseSpec = adjust(Type.object({
    accountId: Type.string,
    accountDataToken: Type.string,
}), { strict: false });

function details$1(apiUrl, accessToken, customerId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = validateResponse;
                    _b = [personalDetailsResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/details", {
                            method: 'GET',
                            headers: __assign(__assign({}, acceptJson), authHeader(accessToken)),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
            }
        });
    });
}
function updateDetails(apiUrl, accessToken, customerId, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = unwrapResponse;
                    return [4 /*yield*/, fetch(apiUrl + "/customers/customer/" + encodeURIComponent(customerId) + "/details", {
                            method: 'POST',
                            headers: __assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)),
                            body: JSON.stringify(request),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}

function create$2(apiUrl, request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, personalDetails, _c, optins, loginRedirectUrl, emailAddress, optInsUpdate, additionalData, stateParams, body, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _a = request.additionalAccountData, _b = _a.personalDetails, personalDetails = _b === void 0 ? {} : _b, _c = _a.optins, optins = _c === void 0 ? {} : _c;
                    loginRedirectUrl = request.loginRedirectUrl, emailAddress = request.emailAddress;
                    optInsUpdate = Object.keys(optins).length > 0 ? optins : undefined;
                    additionalData = { personalDetails: personalDetails, optins: optInsUpdate };
                    stateParams = { targetAction: 'signUp' };
                    body = __assign({ loginRedirectUrl: loginRedirectUrl,
                        emailAddress: emailAddress, state: JSON.stringify(stateParams) }, additionalData);
                    _d = validateResponse;
                    _e = [createAccountResponseSpec];
                    return [4 /*yield*/, fetch(apiUrl + "/customers/account/create", {
                            method: 'POST',
                            headers: __assign(__assign({}, acceptJson), postJson),
                            body: JSON.stringify(body),
                        })];
                case 1: return [2 /*return*/, _d.apply(void 0, _e.concat([_f.sent()]))];
            }
        });
    });
}

var FormName;
(function (FormName) {
    FormName["personalDetails"] = "personalDetails";
    FormName["billingAddress"] = "billingAddress";
    FormName["preferredStore"] = "preferredStore";
})(FormName || (FormName = {}));



var index$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Password: index$3,
    Subscriptions: index$5,
    Prescriptions: index$4,
    PasswordTypes: types$2,
    SubscriptionsTypes: types$4,
    PrescriptionsTypes: types$3,
    details: details$1,
    updateDetails: updateDetails,
    create: create$2,
    get FormName () { return FormName; }
});

var getPlacePredictions = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [placePredictionsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/place/predictions?name=" + request.place, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var getCoordinates = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [coordinatesResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/address/coordinates?address=" + request.query, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };



var index$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getPlacePredictions: getPlacePredictions,
    getCoordinates: getCoordinates
});

var create$3 = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'POST',
                        headers: __assign(__assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)), correlationHeader()),
                        body: JSON.stringify(request),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var createForCustomer = function (apiUrl, customerId, accessToken, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/customer/" + encodeURIComponent(customerId) + "/create", {
                        method: 'POST',
                        headers: __assign(__assign(__assign(__assign(__assign({}, acceptJson), postJson), authHeader(accessToken)), apigeeApiKey(apiKey)), correlationHeader()),
                        body: JSON.stringify(request),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var integerAbove0$1 = constrain(integerSpec, [Constraint.number.above(0)]);
var localizedStringSpec = adjust(Type.map(Type.string, Type.string), { skipInvalidValues: true });
var addressSpec$1 = adjust(Type.map(Type.string, Type.string), { skipInvalidValues: true });
var money = adjust(Type.object({
    currency: Type.string,
    amount: positiveIntegerSpec,
    precision: integerAbove0$1,
}), { strict: false });
var productSchemaBase = {
    name: localizedStringSpec,
    sku: Type.string,
    imageId: optional(Type.string),
};
var attributesSchemaBase = {
    brand: Type.string,
    brandModel: optional(Type.string),
};
var contactLensAttributeTypes = {
    'Contact-lenses': 1,
};
var contactLensBundleAttributeTypes = {
    'Contact-lens-bundles': 1,
};
var contactLensesAttributesSchemaBase = {
    packageQuantity: positiveIntegerSpec,
    replacementFrequency: localizedStringSpec,
    eyeSide: optional(Type.literal({
        left: 1,
        right: 1,
        both: 1,
    })),
    isSubscription: optional(Type.boolean),
    // temporary property, needs be removed when LiquidPixel is replaced with Bynder
    sapArticleNumber: optional(Type.string),
};
var contactLensesProductSpec = adjust(Type.object(__assign(__assign({ attributesType: Type.literal(contactLensAttributeTypes) }, productSchemaBase), { attributes: adjust(Type.object(contactLensesAttributesSchemaBase), { strict: false }) })), { strict: false });
var contactLensesBundleAttributesSchemaBase = {
    lensType: localizedStringSpec,
    isSubscription: Type.boolean,
    months: positiveIntegerSpec,
    imageSku: optional(Type.string),
    fixedDiscount: optional(Type.number),
    leftLensAxis: optional(Type.number),
    leftLensBaseCurve: optional(Type.number),
    leftLensCylinder: optional(Type.number),
    leftLensDiameter: optional(Type.number),
    leftLensName: optional(Type.string),
    leftLensPower: optional(Type.number),
    leftLensSku: optional(Type.string),
    leftLensVariantSku: optional(Type.string),
    rightLensAxis: optional(Type.number),
    rightLensBaseCurve: optional(Type.number),
    rightLensCylinder: optional(Type.number),
    rightLensDiameter: optional(Type.number),
    rightLensName: optional(Type.string),
    rightLensPower: optional(Type.number),
    rightLensSku: optional(Type.string),
    rightLensVariantSku: optional(Type.string),
    solutionName: optional(Type.string),
    solutionSku: optional(Type.string),
};
var contactLensesBundleSpec = adjust(Type.object(__assign(__assign({ attributesType: Type.literal(contactLensBundleAttributeTypes) }, productSchemaBase), { attributes: adjust(Type.object(contactLensesBundleAttributesSchemaBase), { strict: false }) })), { strict: false });
var contactLensesProductDetailsSpec = adjust(Type.object(__assign(__assign({ attributesType: Type.literal(contactLensAttributeTypes) }, productSchemaBase), { attributes: adjust(Type.object(__assign(__assign({}, contactLensesAttributesSchemaBase), { baseCurve: Type.string, diameter: Type.string, power: Type.string, axis: optional(Type.string), cylinder: optional(Type.string), addition: optional(Type.string) })), { strict: false }) })), { strict: false });
var solutionAttributeTypes = { Solutions: 1 };
var solutionProductSpec = adjust(Type.object(__assign(__assign({ attributesType: Type.literal(solutionAttributeTypes) }, productSchemaBase), { attributes: adjust(Type.object({
        brand: attributesSchemaBase.brand,
        solutionType: Type.string,
        volume: positiveIntegerSpec,
    }), { strict: false }) })), { strict: false });
var sunglassesAttributeTypes = { sunglasses: 1 };
var sunglassesProductSpec = adjust(Type.object(__assign(__assign({ attributesType: Type.literal(sunglassesAttributeTypes) }, productSchemaBase), { attributes: adjust(Type.object(__assign({}, attributesSchemaBase)), { strict: false }) })), { strict: false });
var framesAttributeTypes = { frames: 1 };
var framesProductSpec = adjust(Type.object(__assign(__assign({ attributesType: Type.literal(framesAttributeTypes) }, productSchemaBase), { attributes: adjust(Type.object(__assign({}, attributesSchemaBase)), { strict: false }) })), { strict: false });
var otherProductSpec = adjust(Type.object(__assign(__assign({ attributesType: optional(Type.literal({})) }, productSchemaBase), { attributes: adjust(Type.object({}), { strict: false }) })), { strict: false });
var allAttributesTypes = __assign(__assign(__assign(__assign(__assign({}, contactLensAttributeTypes), solutionAttributeTypes), sunglassesAttributeTypes), framesAttributeTypes), contactLensBundleAttributeTypes);
var lineItemSchemaBase = {
    catalogPrice: money,
    discountedPrice: optional(money),
    quantity: integerAbove0$1,
};
var historyLineItem = adjust(Type.object(__assign({ product: either(contactLensesProductSpec, contactLensesBundleSpec, solutionProductSpec, framesProductSpec, sunglassesProductSpec, otherProductSpec) }, lineItemSchemaBase)), { strict: false });
var detailsLineItem = adjust(Type.object(__assign({ product: either(contactLensesProductDetailsSpec, contactLensesBundleSpec, solutionProductSpec, framesProductSpec, sunglassesProductSpec, otherProductSpec) }, lineItemSchemaBase)), { strict: false });
var orderBaseSchema = {
    provider: Type.string,
    orderNumber: constrain(Type.string, [Constraint.string.regex(/^[0-9]+$/)]),
    orderDate: Type.dateString,
    shipmentState: optional(Type.literal({
        Shipped: 1,
        Ready: 1,
        Pending: 1,
        Delayed: 1,
        Partial: 1,
        Backorder: 1,
    })),
    totalChargedPrice: money,
};
var orderHistoryItemSpec = adjust(Type.object(__assign(__assign({}, orderBaseSchema), { lineItems: Type.array(historyLineItem) })), { strict: false });
var orderHistoryResponseSpec = adjust(Type.object({
    orders: Type.array(orderHistoryItemSpec),
    total: positiveIntegerSpec,
}), { strict: false });
var orderDetailsItemSpec = adjust(Type.object(__assign(__assign({}, orderBaseSchema), { lineItems: Type.array(detailsLineItem), totalProductsPrice: money, shippingPrice: money, totalAdditionalDiscount: money, shippingAddress: addressSpec$1, billingAddress: addressSpec$1, shippingInfo: adjust(Type.object({
        deliveryMethod: Type.string,
    }), { strict: false }), customerInfo: adjust(Type.object({
        email: Type.string,
        phone: optional(Type.string),
    }), { strict: false }) })), { strict: false });
var orderDetailsResponseSpec = adjust(Type.object({
    order: orderDetailsItemSpec,
}), { strict: false });

var details$2 = function (apiUrl, accessToken, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderDetailsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/customer/" + request.customerId + "/details/" + request.orderId, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), authHeader(accessToken)), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };
var legacyDetails = function (apiUrl, accessToken, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderDetailsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/archives/customer/" + request.customerId + "/details/" + request.orderId + "/crm", {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), authHeader(accessToken)), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var CONTACT_LENSES_TYPE = 'Contact-lenses';
var CONTACT_LENS_BUNDLE_TYPE = 'Contact-lens-bundles';
var SUNGLASSES_TYPE = 'sunglasses';
var SOLUTION_TYPE = 'Solutions';
var isContactLenses = function (product) {
    return product.attributesType === CONTACT_LENSES_TYPE;
};
var isDetailContactLenses = function (product) { return product.attributesType === CONTACT_LENSES_TYPE; };
var isDetailContactLensBundles = function (product) {
    return product.attributesType === CONTACT_LENS_BUNDLE_TYPE;
};
var isSunglasses = function (product) {
    return product.attributesType === SUNGLASSES_TYPE;
};
var isSolution = function (product) {
    return product.attributesType === SOLUTION_TYPE;
};
var isOther = function (product) {
    return product.attributesType === undefined || !CONTACT_LENSES_TYPE || !SOLUTION_TYPE;
};

var list$4 = function (apiUrl, accessToken, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderHistoryResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/customer/" + request.customerId + "/history?offset=" + request.offset + "&limit=" + request.limit, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), authHeader(accessToken)), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };
var legacyList = function (apiUrl, accessToken, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [orderHistoryResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/archives/customer/" + request.customerId + "/history/crm?offset=" + request.offset + "&limit=" + request.limit, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), authHeader(accessToken)), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

var getOrderByToken = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var orderData, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                orderData = request.orderData;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + orderData, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var unlink$1 = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var orderNumber, orderToken, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                orderNumber = request.orderNumber, orderToken = request.orderToken;
                return [4 /*yield*/, fetch(apiUrl + "/orders/" + orderNumber + "/customer?orderDataToken=" + orderToken, {
                        method: 'DELETE',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1:
                response = _a.sent();
                okOrThrow(response);
                return [2 /*return*/, response];
        }
    });
}); };



var index$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    create: create$3,
    createForCustomer: createForCustomer,
    details: details$2,
    legacyDetails: legacyDetails,
    isContactLenses: isContactLenses,
    isDetailContactLenses: isDetailContactLenses,
    isDetailContactLensBundles: isDetailContactLensBundles,
    isSunglasses: isSunglasses,
    isSolution: isSolution,
    isOther: isOther,
    list: list$4,
    legacyList: legacyList,
    getOrderByToken: getOrderByToken,
    unlink: unlink$1
});

var completeAdyenPayment = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var details, paymentData, paymentId, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                details = request.details, paymentData = request.paymentData, paymentId = request.paymentId;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/payments/adyen/complete", {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify({ details: details, paymentData: paymentData, paymentId: paymentId }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var completeAdyenKlarnaPayment = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var details, paymentData, paymentId, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                details = request.details, paymentData = request.paymentData, paymentId = request.paymentId;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/payments/adyen/complete", {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify({ details: details, paymentData: paymentData, paymentId: paymentId }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var completeAdyen3DSecurePayment = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var details, paymentData, paymentId, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                details = request.details, paymentData = request.paymentData, paymentId = request.paymentId;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/payments/adyen/complete", {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify({ details: details, paymentData: paymentData, paymentId: paymentId }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };



var index$9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    completeAdyenPayment: completeAdyenPayment,
    completeAdyenKlarnaPayment: completeAdyenKlarnaPayment,
    completeAdyen3DSecurePayment: completeAdyen3DSecurePayment
});

var validateRequest = function (spec, request) {
    var _a = verify(spec, request), err = _a.err, value = _a.value;
    if (err) {
        throw err;
    }
    return value();
};

var amountSchema = {
    currency: nonEmptyStringSpec,
    value: positiveIntegerSpec,
    fractionDigits: positiveIntegerSpec,
};
var resultSchema = {
    status: Type.literal({
        success: 1,
        pending: 1,
        failed: 1,
        redirect: 1,
    }),
    description: Type.string,
};
var creditcardPaymentSpec = adjust(Type.object({
    sibsPaymentId: nonEmptyStringSpec,
    timestamp: Type.string,
    result: adjust(Type.object(resultSchema), { strict: false }),
}), { strict: false });
var initCreditcardPaymentRequestSpec = Type.object({
    amount: adjust(Type.object(amountSchema), { strict: false }),
    cartId: nonEmptyStringSpec,
});
var initCreditcardPaymentResponseSpec = adjust(Type.object({
    creditcardPayment: creditcardPaymentSpec,
    paymentInitToken: Type.string,
}), { strict: false });

var initCreditcardPayment = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var validatedRequest, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                validatedRequest = validateRequest(initCreditcardPaymentRequestSpec, request);
                _a = validateResponse;
                _b = [initCreditcardPaymentResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/initialize/sibs/creditcard", {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify(validatedRequest),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };



var index$a = /*#__PURE__*/Object.freeze({
    __proto__: null,
    initCreditcardPayment: initCreditcardPayment
});

var getPaymentMethods = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var countryCode, shippingMethod, isSubscription, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                countryCode = request.countryCode, shippingMethod = request.shippingMethod, isSubscription = request.isSubscription;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/paymentMethods", {
                        method: 'POST',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                        body: JSON.stringify({ countryCode: countryCode, shippingMethod: shippingMethod, isSubscription: isSubscription }),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Multibanco"] = "multibanco";
    PaymentMethod["MBway"] = "mbway";
    PaymentMethod["Creditcard"] = "creditcard";
    PaymentMethod["Ideal"] = "ideal";
    PaymentMethod["Paypal"] = "paypal";
    PaymentMethod["Klarna"] = "klarna";
    PaymentMethod["KlarnaAccount"] = "klarna_account";
    PaymentMethod["CashOnDelivery"] = "cashOnDelivery";
    PaymentMethod["Fake"] = "fake";
    PaymentMethod["BancontactCard"] = "bancontactCard";
    PaymentMethod["MobilePay"] = "mobilepay";
})(PaymentMethod || (PaymentMethod = {}));
var PaymentServiceProvider;
(function (PaymentServiceProvider) {
    PaymentServiceProvider["Sibs"] = "sibs";
    PaymentServiceProvider["Adyen"] = "adyen";
    PaymentServiceProvider["Fake"] = "fake";
    PaymentServiceProvider["CashOnDelivery"] = "cashOnDelivery";
})(PaymentServiceProvider || (PaymentServiceProvider = {}));
var PaymentResult;
(function (PaymentResult) {
    PaymentResult["Success"] = "success";
    PaymentResult["Pending"] = "pending";
    PaymentResult["Failed"] = "failed";
    PaymentResult["Redirect"] = "redirect";
})(PaymentResult || (PaymentResult = {}));
var Gender;
(function (Gender) {
    Gender["Male"] = "MALE";
    Gender["Female"] = "FEMALE";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
var CartState;
(function (CartState) {
    CartState["Active"] = "Active";
    CartState["Merged"] = "Merged";
    CartState["Ordered"] = "Ordered";
})(CartState || (CartState = {}));
/**
 * Adyen callback result codes
 */
var CallbackResultCode;
(function (CallbackResultCode) {
    CallbackResultCode["Authorised"] = "authorised";
    CallbackResultCode["Cancelled"] = "cancelled";
    CallbackResultCode["Refused"] = "refused";
    CallbackResultCode["Pending"] = "pending";
    CallbackResultCode["Received"] = "received";
})(CallbackResultCode || (CallbackResultCode = {}));

var types$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get PaymentMethod () { return PaymentMethod; },
    get PaymentServiceProvider () { return PaymentServiceProvider; },
    get PaymentResult () { return PaymentResult; },
    get CartState () { return CartState; },
    get CallbackResultCode () { return CallbackResultCode; }
});



var index$b = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Adyen: index$9,
    Sibs: index$a,
    getPaymentMethods: getPaymentMethods,
    get PaymentMethod () { return PaymentMethod; },
    get PaymentServiceProvider () { return PaymentServiceProvider; },
    get PaymentResult () { return PaymentResult; },
    get CartState () { return CartState; },
    get CallbackResultCode () { return CallbackResultCode; }
});

var query = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var category, expand, facets, filters, pageIndex, pageSize, sortBy, sortDirection, queryParams, endpoint, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                category = (request && request.categoryType) || undefined;
                expand = request && request.expand ? request.expand.join('|') : undefined;
                facets = request && request.facets ? request.facets.join('|') : undefined;
                filters = request && request.filters ? request.filters.join('|') : undefined;
                pageIndex = (request && request.pageIndex) || 1;
                pageSize = (request && request.pageSize) || 24;
                sortBy = (request && request.sortBy) || 'price';
                sortDirection = (request && request.sortDirection) || 'asc';
                queryParams = QueryString.stringify({
                    expand: expand,
                    filters: filters,
                    facets: facets,
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    sortBy: sortBy,
                    sortDirection: sortDirection,
                }, true, '&', '=', false);
                endpoint = category ? "/category/" + category + "/" : '/';
                _a = unwrapResponse;
                return [4 /*yield*/, fetch("" + apiUrl + endpoint + "?" + queryParams, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getProductById = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var expand, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                expand = request.expand ? request.expand.join('|') : null;
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.productId + "?expand=" + expand, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var getProductBySlug = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var expands, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                expands = request.expand || [
                    'masterVariant.prices[*].discounted.discount',
                    'variants[*].prices[*].discounted.discount',
                    'taxCategory',
                    'masterVariant.attributes[*].value',
                    'categories[*]',
                    'productType',
                    'review-enabled',
                ];
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/slug/" + request.slug + "?expand=" + expands.join('|'), {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getCategoryByKey = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/categories/" + request.key, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getContactLenses = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/contactlenses/" + request.variantGroup, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
var getContactLensBundles = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var expands, queryParams, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                expands = [
                    'masterVariant.prices[*].discounted.discount',
                    'variants[*].prices[*].discounted.discount',
                    'masterVariant.attributes[*].value',
                    'productType',
                ];
                queryParams = QueryString.stringify({
                    expand: expands.join('|'),
                    filters: "variants.sku:\"" + request.sku + "\"",
                    solutions: true,
                }, true, '&', '=', false);
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/?" + queryParams, {
                        method: 'GET',
                        headers: __assign(__assign(__assign({}, acceptJson), postJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };



var index$c = /*#__PURE__*/Object.freeze({
    __proto__: null,
    query: query,
    getProductById: getProductById,
    getProductBySlug: getProductBySlug,
    getCategoryByKey: getCategoryByKey,
    getContactLenses: getContactLenses,
    getContactLensBundles: getContactLensBundles
});

var localizedStringSpec$1 = Type.map(Type.string, Type.string);
var townItem = adjust(Type.object({
    town: Type.string,
    townLocalized: optional(localizedStringSpec$1),
}), { strict: false });
var townsResponseSpec = Type.array(townItem);
var storeSitemapItem = adjust(Type.object({
    slug: Type.string,
    slugLocalized: optional(localizedStringSpec$1),
    town: Type.string,
    townLocalized: optional(localizedStringSpec$1),
}), { strict: false });
var storeSitemapResponseSpec = Type.array(storeSitemapItem);

var getTowns = function (apiUrl, _request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [townsResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/towns", {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };

/**
 * Lists all stores for an opco
 */
var list$5 = function (apiUrl, _request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/list", {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
/**
 * Retrieve details of a single store using the store code.
 */
var getDetailsByCode = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/" + request.code, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
/**
 * Function to retrieve a list of stores based on a filter parameter
 * Currently only supports slug lookup
 */
var getStoresByFilter = function (apiUrl, request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = unwrapResponse;
                return [4 /*yield*/, fetch(apiUrl + "/retrieve/filter?name=" + request.filter + "&value=" + request.value, {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };

var getStoreSitemap = function (apiUrl, _request, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = validateResponse;
                _b = [storeSitemapResponseSpec];
                return [4 /*yield*/, fetch(apiUrl + "/sitemap", {
                        method: 'GET',
                        headers: __assign(__assign({}, acceptJson), apigeeApiKey(apiKey)),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()]))];
        }
    });
}); };



var index$d = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getTowns: getTowns,
    list: list$5,
    getDetailsByCode: getDetailsByCode,
    getStoresByFilter: getStoresByFilter,
    getStoreSitemap: getStoreSitemap
});



var types$6 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var initialState = [true, undefined, undefined];
function reducer(state, action) {
    switch (action.type) {
        case 'RESET':
            return initialState;
        case 'SUCCESS':
            return [false, action.payload, undefined];
        case 'FAILURE':
            return [false, undefined, action.payload];
    }
}
/**
 * Use one of the api-client's functions as a hook. The first argument is the
 * API function itself. The rest of the argument are the API function's
 * parameters.
 *
 * For example:
 *
 *    const [loading, result, error] = useApiClient(
 *      Orders.list,
 *      apiUrl,
 *      accessToken,
 *      { customerId, limit, offset }
 *    )
 *
 *  Note: the type of the rest arguments and of `result` are inferred from the
 *  given API function.
 */
function useApiClient(apiFunc, options) {
    var params = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        params[_i - 2] = arguments[_i];
    }
    var _a = __read(useReducer(reducer, initialState), 2), state = _a[0], dispatch = _a[1];
    useEffect(function () {
        var cancelled = false;
        dispatch({ type: 'RESET' });
        if (options && options.skip) {
            return;
        }
        apiFunc.apply(void 0, __spread(params)).then(function (result) { return cancelled || dispatch({ type: 'SUCCESS', payload: result }); })
            .catch(function (error) { return cancelled || dispatch({ type: 'FAILURE', payload: error }); });
        return function () {
            cancelled = true;
        };
    }, __spread([options && options.skip], params));
    return state;
}

export { index as AddressBook, index$1 as Appointments, index$2 as Carts, index$6 as Customers, index$7 as Location, index$8 as Orders, types$5 as PaymentTypes, index$b as Payments, index$c as Products, index$d as Stores, types$6 as Types, useApiClient };
//# sourceMappingURL=index.es.js.map
